import { graphql } from "gql.tada";

export const resultingListSubscription = graphql(`
  subscription ($input: ProductListViewInput!) {
    productListView(input: $input) {
      ... on ProductListView {
        viewType
        parentProductSeriesId
        parentProductOrderCodeState {
          optionStates {
            isSizePart
            optionKey
            partKey
            separator
            signatureKey
            signatureValue
            parentRef {
              partKey
              optionKey
            }
            signaturePresentation
          }
          lastChange {
            isSizePart
            optionKey
            partKey
            separator
            signatureKey
            signatureValue
            parentRef {
              partKey
              optionKey
            }
            signaturePresentation
          }
        }
        listViewData {
          columnTitles {
            key
            title
            subTitles {
              key
              title
              subTitles {
                key
                title
                subTitles {
                  key
                  title
                }
              }
            }
          }
          productListViewItems {
            ordercodeState {
              optionStates {
                isSizePart
                optionKey
                partKey
                separator
                signatureKey
                signatureValue
                signaturePresentation
              }
              lastChange {
                isSizePart
                optionKey
                partKey
                separator
                signatureKey
                signatureValue
                signaturePresentation
              }
            }
            selectedAccessories {
              seriesId
              seriesName
              currentPresentation
              ordercode {
                presentation
              }
              accessoryId
              accessoryGroupId
              infoText
              optionStates {
                isSizePart
                optionKey
                partKey
                separator
                signatureKey
                signatureValue
                parentRef {
                  partKey
                  optionKey
                }
                signaturePresentation
              }
              lastChange {
                isSizePart
                optionKey
                partKey
                separator
                signatureKey
                signatureValue
                parentRef {
                  partKey
                  optionKey
                }
                signaturePresentation
              }
              pimId
            }
            properties {
              propertyId
              value
              validationMessage
              validationResult
            }
          }
        }
      }

      ... on ProductListViewErrorEvent {
        message
        traceId
      }
    }
  }
`);
